import { render, staticRenderFns } from "./StatisticCards.vue?vue&type=template&id=7863a0b6&scoped=true"
import script from "./StatisticCards.vue?vue&type=script&lang=js"
export * from "./StatisticCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863a0b6",
  null
  
)

export default component.exports